<!-- eslint-disable vue/no-v-html -->
<template>
  <page
    :custom-style="{
      padding: '10px',
      backgroundColor: '#f5f5f5',
      minHeight: '100vh',
      boxSizing: 'border-box'
    }"
    :custom-class="'page-wrapper'"
  >
    <scroll-view
      class="scroll-wrapper"
      :reach-bottom-loading="loading"
      :finish="isLastPage && !empty"
      @loadData="loadData"
    >
      <CouponItem
        v-for="(couponItem, index) in couponList"
        :key="index"
        :item-data="couponItem"
        @go-transfer="goTransfer"
      >
      </CouponItem>
      <!-- 缺省展示 -->
      <div v-show="empty" class="empty">
        <img src="@/images/seckill/empty.png" width="40%" />
        <p>暂无企业钱包充值优惠券</p>
      </div>
    </scroll-view>
    <van-popup v-model="showCompanyList" round position="bottom">
      <div class="popup-wrapper">
        <div class="popup-title">
          选择转赠门店
          <div class="close-btn" @click="closePopup">
            <IconFont
              name="guanbi"
              size=".24rem"
              color="#666"
              class="icon-font"
            ></IconFont>
          </div>
        </div>
        <scroll-view class="scroll-view-wrapper">
          <div
            v-for="item in companyList"
            :key="item.id"
            class="company-item"
            @click="select(item)"
          >
            <div class="select-operate">
              <IconFont
                :name="
                  selectId === item.id
                    ? 'xuankuang-gouxuan'
                    : 'xuankuang-weixuanzhong'
                "
                :color="selectId === item.id ? '#15bb5c' : '#CCCCCC'"
                size="20px"
              ></IconFont>
            </div>
            <div class="info">
              <div class="name-wrapper">
                <img src="@/images/recharge_coupon/store.png" class="tag" />
                <span class="name"> {{ item.name }}</span>
              </div>
              <div class="address">{{ item.address }}</div>
            </div>
          </div>
        </scroll-view>
        <div class="transfer-btn-wrapper">
          <div class="btn" @click="transferClick">转赠</div>
        </div>
      </div>
    </van-popup>
  </page>
</template>
<script>
import { API } from '@/api'
import { navBar } from '@/utils/native_interactions/native_bar'
import ScrollView from '@/common/widgets/scroll_view'
import CouponItem from './couponItem.vue'
import { Dialog } from 'vant'
import { THEME_COLOR } from '@/defines/environment/config'

export default {
  components: {
    ScrollView,
    CouponItem
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      navBar.setTitle({
        text: '企业钱包充值优惠券'
      })
      document.title = '企业钱包充值优惠券'
    })
  },
  data() {
    return {
      loading: false, // 触底loading
      couponList: [],
      isLastPage: false,
      showCompanyList: false,
      selectId: '',
      companyList: [],
      transferCoupon: '',
      page: 1
    }
  },
  computed: {
    empty() {
      return this.couponList?.length === 0
    }
  },
  created() {
    this.$Loading()
    this.initData()
  },
  methods: {
    initData() {
      this.page = 1
      this.couponList = []
      this.isLastPage = false
      this.selectId = ''
      this.transferCoupon = ''
      this.loading = false
      this.showCompanyList = false
      this.companyList = []
      this.myCouponList(this.page)
    },
    closePopup() {
      this.showCompanyList = false
    },
    async goTransfer(couponId) {
      this.transferCoupon = couponId
      try {
        const res = await API.coupon.listTransferableUnit()
        this.companyList = res?.units || []
        this.showCompanyList = this.companyList.length > 0
        if (!this.showCompanyList) {
          this.$toast('企业钱包下没有其他门店可转赠优惠券')
        }
      } catch (e) {
        this.$catch(e)
      }
    },
    select(item) {
      this.selectId = item.id
    },

    transferClick() {
      Dialog.confirm({
        message: `转赠后优惠券无法回收，确认转赠？`,
        cancelButtonText: '取消',
        confirmButtonText: '确认转赠',
        confirmButtonColor: THEME_COLOR,
        cancelButtonColor: '#999'
      }).then(() => {
        this.confrimTransfer()
      })
    },
    async confrimTransfer() {
      try {
        await API.coupon.transferCoupon({
          transferToUserId: this.selectId,
          couponId: this.transferCoupon
        })
        this.$toast('转赠成功')
        this.closePopup()
        this.initData()
      } catch (e) {
        this.$catch(e)
      }
    },
    async myCouponList(page) {
      this.loading = true
      try {
        const res = await API.coupon.myCouponList({
          size: 10,
          page,
          supportTransfer: 1
        })
        this.loading = false
        this.$Loading.hide()
        const list = res?.rows || []
        this.couponList = this.couponList.concat(list)
        this.isLastPage = res.isLastPage
      } catch (e) {
        this.loading = false
        this.$Loading.hide()
        this.couponList = []
        this.isLastPage = true
        this.$catch(e)
      }
    },
    // 滚动加载
    loadData() {
      this.page = this.page + 1
      this.myCouponList(this.page)
    }
  }
}
</script>
<style lang="scss" scoped>
.page-wrapper {
  @include iphonex-padding-bottom(4px);
}
.scroll-wrapper {
  height: 100%;

  &::-webkit-scrollbar {
    display: none;
  }
}
.empty {
  height: 100%;
  display: flex;

  justify-content: center;

  flex-direction: column;
  align-items: center;

  & > p {
    margin-top: 20px;

    font-size: 0.24rem;
    color: #666;
  }
}
.popup-wrapper {
  height: 80vh;
  display: flex;
  flex-direction: column;
  .popup-title {
    height: 1.04rem /* 52/50 */;
    position: relative;
    @include flex-row-center;
    @include text(0.32rem /* 16/50 */, #333333, true);
    .close-btn {
      width: 20px;
      height: 20px;
      position: absolute;
      right: 0.2rem /* 10/50 */;
      top: 50%;
      margin-top: -10px;
    }
  }
  .scroll-view-wrapper {
    flex: auto;
    height: 0;
    &::-webkit-scrollbar {
      display: none;
    }
  }
}
.company-item {
  @include flex-row-center;
  padding: 0.4rem /* 20/50 */ 0.4rem /* 20/50 */ 0.32rem /* 16/50 */ 0.3rem
    /* 15/50 */;
  background: #fff;
  box-sizing: border-box;

  .select-operate {
  }

  .info {
    flex: auto;
    width: 0;
    margin-left: 0.24rem /* 12/50 */;
    .name-wrapper {
      @include flex(row, normal, center);
      .tag {
        width: 0.52rem /* 26/50 */;
        height: 0.28rem /* 14/50 */;
        margin-right: 0.12rem /* 6/50 */;
      }
      .name {
        @include text(0.28rem /* 14/50 */, #262626, true);
        @include text-overflow-ellipsis;
      }
    }

    .address {
      @include text(14px, #999999);
      @include text-overflow-ellipsis;
      margin-top: 0.18rem /* 9/50 */;
    }
  }
}
.transfer-btn-wrapper {
  padding: 0.16rem /* 8/50 */ 0.48rem /* 24/50 */;
  .btn {
    height: 0.88rem /* 44/50 */;
    border-radius: 0.8rem /* 40/50 */;
    @include flex-row-center;
    @include text(0.32rem /* 16/50 */, #fff);
    background-color: $theme-main;
  }
}
</style>
